import { render, staticRenderFns } from "./oldRecordWhitelistMainView.vue?vue&type=template&id=05e5d116&scoped=true&"
import script from "./oldRecordWhitelistMainView.vue?vue&type=script&lang=js&"
export * from "./oldRecordWhitelistMainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e5d116",
  null
  
)

export default component.exports